import Swiper from 'swiper';
import 'swiper/css';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css/pagination';

const carousels = document.querySelectorAll('.services__carousel');

carousels.forEach(carousel => {
  const swiperEl = carousel.querySelector('.swiper');
  const paginationEl = carousel.querySelector('.swiper-pagination');
  const prevEl = carousel.querySelector('.services__nav-button--prev');
  const nextEl = carousel.querySelector('.services__nav-button--next');

  if (!swiperEl) return;

  new Swiper(swiperEl, {
    modules: [Pagination, Autoplay, Navigation],
    slidesPerView: 'auto',
    centeredSlides: false,
    spaceBetween: 18,
    loop: false,
    speed: 650,
    grabCursor: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    autoplay: {
      delay: 4500,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        spaceBetween: 20,
      },
      768: {
        spaceBetween: 24,
      },
      1280: {
        spaceBetween: 32,
      },
    },
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    navigation: {
      prevEl,
      nextEl,
    },
  });
});
